import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SaidaEstoqueInserirRoutingModule } from './saida-estoque-inserir-routing.module';
import { SaidaEstoqueInserirComponent } from './saida-estoque-inserir.component';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';
import { CpfFormatPipe } from 'src/app/admihair/format-pipe/cpf/cpf-format.pipe';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';


@NgModule({
  declarations: [
    SaidaEstoqueInserirComponent
  ],
  imports: [
    CommonModule,
    SaidaEstoqueInserirRoutingModule,
    FormsModule,
    TableModule,
    DialogModule,
    ProgressSpinnerModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    DividerModule,
    MessagesModule,
    CalendarModule,
    TooltipModule,
    FormatPipeModule

  ]
})
export class SaidaEstoqueInserirModule { }
